import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: 'Home', path: '/' },
  { label: 'About', path: '/about' },
  { label: 'Programs', path: '/programs' },
  { label: 'Get Involved', path: '/get-involved' },
  { label: 'Contact', path: '/contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-sm' : 'bg-transparent'
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between h-20">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3 cursor-pointer">
          <img src="/ikiru-logo.jpg" alt="IKIRU Epilepsy Foundation Logo" className="w-10 h-10 rounded-full object-cover" />
          <div>
            <span className={`font-bold text-lg tracking-tight leading-none block ${scrolled ? 'text-gray-900' : 'text-white'}`}>
              IKIRU
            </span>
            <span className={`text-xs tracking-widest uppercase ${scrolled ? 'text-[#7B2D8B]' : 'text-purple-200'}`}>
              Epilepsy Foundation
            </span>
          </div>
        </Link>

        {/* Desktop Nav */}
        <ul className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <li key={link.path}>
              <Link
                to={link.path}
                className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                  location.pathname === link.path
                    ? scrolled ? 'text-[#7B2D8B]' : 'text-purple-300'
                    : scrolled ? 'text-gray-700 hover:text-[#7B2D8B]' : 'text-white/90 hover:text-white'
                }`}
              >
                {link.label}
              </Link>
            </li>
          ))}
        </ul>

        {/* CTA */}
        <div className="hidden md:flex items-center gap-3">
          <Link
            to="/get-involved"
            className="px-5 py-2.5 rounded-full bg-[#7B2D8B] text-white text-sm font-semibold hover:bg-[#6a2578] transition-colors cursor-pointer whitespace-nowrap"
          >
            Donate Now
          </Link>
        </div>

        {/* Mobile Hamburger */}
        <button
          className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${scrolled ? 'text-gray-800' : 'text-white'}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <i className={`text-xl ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </nav>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-6 py-4 flex flex-col gap-4">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              onClick={() => setMenuOpen(false)}
              className={`text-sm font-medium cursor-pointer ${
                location.pathname === link.path ? 'text-[#7B2D8B]' : 'text-gray-700'
              }`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/get-involved"
            onClick={() => setMenuOpen(false)}
            className="px-5 py-2.5 rounded-full bg-[#7B2D8B] text-white text-sm font-semibold text-center cursor-pointer whitespace-nowrap"
          >
            Donate Now
          </Link>
        </div>
      )}
    </header>
  );
}
